import { bool, func, object, string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { FnrPopover } from "UI/FnrPopover2";

SacramentNotePopover.propTypes = {
  show: bool.isRequired,
  content: string,
  onShouldClose: func,
  buttonRef: object.isRequired,
};

export default function SacramentNotePopover({
  show,
  content,
  onShouldClose,
  buttonRef,
}) {
  if (!content) return null;
  const html = JSON.parse(content).value;

  return (
    <FnrPopover
      buttonRef={buttonRef}
      show={show}
      onShouldClose={onShouldClose}
      style={{ maxWidth: "375px" }}
    >
      <Div dangerouslySetInnerHTML={{ __html: html }} />
    </FnrPopover>
  );
}

const Div = styled.div`
  padding-inline: 1rem;
  white-space: pre-line;
`;
